const ITEMS = [
  "Posa a correre 23€/mq",
  "Spina italiana 28€/mq",
  "Spina francese / ungherese 32€/mq",
  "Sopralluogo gratuito",
  "Battiscopa incluso",
  "Lamatura e levigatura",
  "SPC · Laminati · PVC",
  "Roma e provincia",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl italic text-cream/90 md:text-2xl">
          {t}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-honey" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-honey/25 bg-bark py-5"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
